/* src/app/components/service/service-type-forms/csv-importer/csv-upload.component.css */
.hideextra {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 2px 0 2px;
}
.header-text-style {
  font-weight: 500;
  color: var(--fg-1);
}
/*# sourceMappingURL=csv-upload.component.css.map */
